import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'account-orders-list-item',
    templateUrl: './account.orders.list.item.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersListItemComponent {
    @Input('order') order;

    /** Format date string to work in Safari */
    public sanitizeDate(datetime: string) {
        return datetime.replace(/\s/g, 'T');
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/account/orders/list/item/account.orders.list.item.component.ts